module.exports = __webpack_public_path__ + "static/media/Gilroy-Regular.22d25e11.ttf";